
import isString from 'lodash/isString';
import {
    GET_PROJECT_ACTION_TYPE,
    SET_PARAMETER_ACTION_TYPE
} from '../sagas/project';

import { LOGIN_ACTION_TYPE } from '../common/client/sagas/auth';

import {initialState as loaderInitialState, createLoaderReducer} from '../common/client/reducers/loader';

const initialState = {
    ...loaderInitialState
};

export function getIsProjectLoaded(state, projectId) {
    return (
        state.loaded &&
        !state.loading &&
        // eslint-disable-next-line eqeqeq
        (state.data.project.id == projectId)
    );
}

export function getNeedLoadProject(state, projectId, authLoading) {

    const notLoaded = (!state.loaded && !state.loading && !authLoading);
    const anotherId = (state.loaded && (state.data.project.id != projectId)); // eslint-disable-line eqeqeq
    const error = (state.error)

    return ((notLoaded || anotherId) && (!error));
}

export function getProject(state) {
    return state.project;
}

export function getProjectParam(state, name, defaultValue) {
    try {
        let value = state.project.params[name];
        if (!isString(defaultValue)) {
            value = JSON.parse(value);
        }
        if (!value) {
            value = defaultValue;
        }
        return value;
    } catch (e) {
        return defaultValue;
    }
}

export function getProjectKatuzeItems(state) {
    return getProjectParam(state, 'katuzeItems', []);
}

export function getProjectId(state) {
    return state.project.id;
}

export function getProjectStatus(state) {
    return getProjectParam(state, 'status', 'DEF_KU');
}

function setParameter(state, action) {
    return {
        ...state,
        project: {
            ...state.project,
            params: {
                ...state.project.params,
                [action.name]: action.value
            }
        }
    };
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(GET_PROJECT_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {
            case LOGIN_ACTION_TYPE.SUCCESS:
                return {
                    ...initialState
                };

            case GET_PROJECT_ACTION_TYPE.SUCCESS:
                return {
                    ...loaderReducer(state, action),
                    project: action.data.project
                }

            case SET_PARAMETER_ACTION_TYPE.SUCCESS:
                return setParameter(state, action);

            default:
                return loaderReducer(state, action);
        }
    };
}
